import styled from 'styled-components';

import { TextBodyBold, TextBodySmallNormal } from '@/core/components/Typography/Typography.styles';

export const CardLink = styled.a`
  position: relative;
  display: flex;
  align-items: flex-start;
  outline: none;
  border-radius: 8px;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.background.dark};
  color: ${({ theme }) => theme.colors.primaryText};
  text-decoration: none;
  transition: border-color 150ms ease;
  gap: 12px;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.light};
  }
`;

export const Thumbnail = styled.div`
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background.extraLight};
  background-image: repeating-conic-gradient(
    ${({ theme }) => theme.colors.background.light} 0% 25%,
    transparent 0% 50%
  );
  background-size: 16px 16px;
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Body = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
  height: 64px;
  gap: 8px;
`;

export const Title = styled(TextBodyBold)`
  overflow: hidden;
  display: -webkit-box;
  flex: 1;
  min-width: 0;
  margin: 0;
  font-size: 16px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const TimeAgo = styled(TextBodySmallNormal)`
  position: absolute;
  right: 12px;
  bottom: 12px;
  flex-shrink: 0;
  margin-left: 12px;
  white-space: nowrap;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
`;
